module.exports = __webpack_public_path__ + "static/media/download.1effacf7.png";